// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/parachuting-regulations.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/parachuting-regulations/parachuting-regulations.js';

mount([g0]);
